import { Entity } from '@backstage/catalog-model';
import { InfoCard } from '@backstage/core-components';
import { AzureCostSection } from './AzureCostSection';
import { KubernetesCostSection } from './KubernetesCostSection';
import { KUBERNETES_ID_ANNOTATION } from './lib';

export const isCostCardAvailable = (entity: Entity): boolean =>
  Boolean(entity.metadata.annotations?.[KUBERNETES_ID_ANNOTATION]);

const WINDOW = '7d';

/** Two independent sections — neither gates the other, so the Azure section
 * renders whenever the Kubernetes side is loading, errored, or empty (and
 * vice versa). When the Azure section is `hidden` it renders nothing at all,
 * not even a divider. */
export const EntityCostCard = () => (
  <InfoCard title={`Cost (last ${WINDOW})`}>
    <KubernetesCostSection />
    <AzureCostSection />
  </InfoCard>
);
